<template>
  <div v-if="init" class="amap-water-layer-tool">
    <Teleport to="#amap-control">
      <div :class="{ 'water-control': true, 'water-active': showWater }">
        <el-tooltip content="水系图层" effect="dark" placement="left">
          <img src="@p-v/packages/Map/AMapChart/assets/water.png" alt="水系图层" class="water-icon" @click="toggleWater" />
        </el-tooltip>
      </div>
    </Teleport>
  </div>
</template>

<script lang="ts" setup>
import { ref, inject, watch, computed, onMounted } from "vue"
import { ElTooltip } from "element-plus"

defineOptions({
  name: "AMapTextLayer",
})
const props = defineProps({
  // 是否初始化完成
  show: {
    type: Boolean,
    default: false,
  },
})
const init = ref<boolean>(false)

const emit = defineEmits(["water-toggle"])

// 从父组件注入地图实例
const amap = inject<any>("amap")
const mapFeatures = inject<any>("mapFeatures")

const showWater = computed(() => {
  // 如果地图特性中包含"bg"，则表示水系 图层已显示
  return mapFeatures.value.includes("bg")
})

// 监听地图实例变化
watch(
  () => amap.value,
  map => {
    if (map) {
      // 初始化水系图层工具
      console.log("初始化水系图层工具", map)
      init.value = true
    }
  },
  { immediate: true },
)

// 切换水系图层显示/隐藏
const toggleWater = () => {
  if (!amap.value) return

  if (!showWater.value) {
    // 显示水系
    showWaterLayer()
  } else {
    // 隐藏水系
    hideWaterLayer()
  }

  // 发送状态变更事件
  emit("water-toggle", showWater.value)
}

// 显示水系图层
const showWaterLayer = () => {
  if (!amap.value) return
  if (mapFeatures.value.includes("bg")) {
    // 如果地图已经包含水系特性，则不需要重复设置
    return
  }
  mapFeatures.value.push("bg")
  // 设置地图显示所有特性（包括POI文字）
  amap.value.setFeatures(mapFeatures.value)
}

// 隐藏水系图层
const hideWaterLayer = () => {
  if (!amap.value) return

  if (!mapFeatures.value.includes("bg")) {
    // 如果地图已经包含水系特性，则不需要重复设置
    return
  }
  mapFeatures.value = mapFeatures.value.filter((feature: string) => feature !== "bg")
  // 设置地图显示所有特性（包括POI文字）
  amap.value.setFeatures(mapFeatures.value)
}

onMounted(() => {
  if (props.show) {
    // 如果show为true，直接显示水系图层
    showWaterLayer()
  } else {
    // 否则隐藏水系图层
    hideWaterLayer()
  }
})

// 暴露方法
defineExpose({
  toggleWater,
  showWaterLayer,
  hideWaterLayer,
})
</script>

<style scoped>
.amap-water-layer-tool {
  display: contents;
}

.water-control {
  background-color: white;
  padding: 5px;
  filter: grayscale(1); /* 默认显示水系，所以默认不灰度 */
  img {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
}

.water-active {
  filter: grayscale(0);
}

/* .water-control:not(.water-active) {
  filter: grayscale(1);
  background-color: #f0f0f0;
} */
</style>
